import { Badge, Card } from "@procurement-agents/ui";
import { isFullConfig, phasesFor } from "@procurement-agents/scope-api";
import { Link } from "react-router-dom";
import { PHASES, relativeTime } from "../labels";
import { useAgents } from "./AgentsApp";
import { STEPS } from "./labels";

/** The module's main menu: the workflows this customer runs. One today (scope generation); selecting it opens its
 *  agents. Everything under a workflow — its steps, its agents, previews and releases — belongs to that workflow. */
export function Workflows({ base }: { base: string }) {
  const { overview, shown } = useAgents();
  const profile = isFullConfig(shown) ? shown.profile : null;
  const steps = profile ? STEPS.filter((s) => s.fixed || s.flag === "structure_decision" || !!profile[s.flag!]).length : null;
  const phases = profile ? phasesFor(profile, PHASES.map((p) => p.id)).length : null;
  const pub = overview.published;
  return (
    <section className="workflows">
      <p className="muted small">The workflows this customer runs. Open one to see its agents and how it is configured.</p>
      <Link to={`${base}/agents`} className="workflow-card">
        <Card title={<>Scope generation {overview.draft && <Badge tone="info">draft v{overview.draft.version}</Badge>}</>}>
          <p>A business need becomes a scope of work: intake, requisition, market research, the structure decision, drafting, QA and SME review.</p>
          <dl className="dl workflow-facts">
            <dt>Agents</dt><dd>{overview.agent_roles.length}</dd>
            {steps !== null && <><dt>Steps</dt><dd>{steps} of {STEPS.length} enabled, {phases} stages in the journey</dd></>}
            <dt>Published</dt><dd>v{pub.version}{pub.published_at ? ` ${relativeTime(pub.published_at)}` : ""}{pub.published_by ? ` by ${pub.published_by}` : ""}</dd>
          </dl>
          <p className="link-cue small">Open this workflow →</p>
        </Card>
      </Link>
      <p className="muted small">Other workflows, such as evaluation report generation, will be listed here once they are configurable.</p>
    </section>
  );
}
